import * as c from '../constants/actionTypes';

let initialState = {
  students: [],
  totalStudents: 0,
  editors: [],
  totalEditors: 0,
  affiliates: []
}

export default (state = initialState, action) => {
  switch(action.type) {
    case c.GET_ADMINUSERCOLLECTION_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
  case c.GET_ADMINSTUDENTCOLLECTION_SUCCESS:
    var newState = state;
    newState.students = action.body.students;
    newState.totalStudents = action.body.totalCount;
    return Object.assign({}, state, newState);
  case c.GET_ADMINUSERCOLLECTION_SUCCESS:
      var newState = state;
      newState.editors = action.body.editors;
      newState.totalEditors = action.body.totalCount;
      return Object.assign({}, state, newState);
    case c.GET_ADMINUSERCOLLECTION_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case c.ADD_AFFILIATE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case c.REMOVE_AFFILIATE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case c.GET_AFFILIATES_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case c.GET_AFFILIATES_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case c.GET_AFFILIATES_SUCCESS:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
      default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AdminUserCollection.js